import React, { useState } from 'react';
import { ActionButtonPresenter } from '../../atom/ActionButton';
import { CommandActionsModal } from '../../../../features/commandBus';

export interface ActionPresenterProps {
  deviceId?: string;
  buttonSize?: 'small' | 'medium' | 'large';
  buttonVariant?: 'primary' | 'secondary' | 'tercery';
  buttonLabel?: string;
  disabled?: boolean;
}

// Opens the command-bus "Actions" modal (catalog commands + history) for a
// device. The previous settings/reset/maintenance modal was retired in favour
// of the command bus, so this is now a thin button + modal wrapper.
export default function ActionPresenter({
  deviceId,
  buttonSize = 'medium',
  buttonVariant = 'primary',
  buttonLabel,
  disabled = false,
}: ActionPresenterProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ActionButtonPresenter
        onOpenModal={() => setIsOpen(true)}
        disabled={disabled}
        size={buttonSize}
        variant={buttonVariant}
        label={buttonLabel}
      />
      {deviceId && (
        <CommandActionsModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          devEui={deviceId}
        />
      )}
    </>
  );
}
